import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { HeaderManager } from 'inside-out/managers/headerManager';
import MyselfBG from 'inside-out/images/register/myself-bg.svg';
import SomeoneIKnowBG from 'inside-out/images/register/someone-i-know-bg.svg';

import {
	wrapperStyle,
	innerWrapperStyle,
	titleStyle,
	textStyle,
	cardsWrapStyle,
	cardsSectionStyle,
} from 'inside-out/page-styles/screener';

import { Cards } from 'inside-out/components/shared/cards';
import { ColouredCard } from 'inside-out/components/shared/cards/colouredCard';
import { contentSection, tabletPortraitMaxWidthBreakpoint } from 'inside-out/global-styles';

export default class ScreenerPage extends React.PureComponent {
	static propTypes = {
		data: PropTypes.shape({
			page: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							heading: PropTypes.string.isRequired,
							body: PropTypes.string.isRequired,
							consumer_tile_label: PropTypes.string.isRequired,
							carer_tile_label: PropTypes.string.isRequired,
						}).isRequired,
					})
				).isRequired,
			}).isRequired,
		}).isRequired,
	};

	componentDidMount = () => {
		HeaderManager.headerProperties = {};
	};

	render() {
		const pageSettings = this.props.data.page.edges[0].node;

		return (
			<div className={wrapperStyle}>
				<Helmet title={pageSettings.heading}>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={pageSettings.heading}/>
        </Helmet>

				<section className={contentSection('#fff')}>
					<div className={innerWrapperStyle}>
						<header>
							<h1 className={titleStyle}>{pageSettings.heading}</h1>
						</header>
						<div
							className={textStyle}
							dangerouslySetInnerHTML={{
								__html: pageSettings.body,
							}}
						/>
					</div>
				</section>

				<div className={cardsWrapStyle}>
					<div className={innerWrapperStyle}>
						<section className={cardsSectionStyle}>
							<Cards
								columns={2}
								scrollable={false}
								columnsAt={{
									[`max-width: ${tabletPortraitMaxWidthBreakpoint}`]: 1,
								}}
							>
								<ColouredCard
									id={0}
									to="/screener/for-myself"
									background={`#F5A81E url(${MyselfBG}) no-repeat bottom right`}
									minHeight={210}
									title={pageSettings.consumer_tile_label}
									arrow={true}
								/>
								<ColouredCard
									id={1}
									to="/screener/carer"
									background={`#F26C22 url(${SomeoneIKnowBG}) no-repeat bottom right`}
									minHeight={210}
									title={pageSettings.carer_tile_label}
									arrow={true}
								/>
							</Cards>
						</section>
					</div>
				</div>
			</div>
		);
	}
}

export const query = graphql`
	query ScreenerLandingPageQuery {
		page: allContentJson(filter: { id: { regex: "/content\\/screener-landing-page\\.json/" } }) {
			edges {
				node {
					heading
					body
					consumer_tile_label
					carer_tile_label
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/screener/index.js